import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLang } from '@/i18n';
import css from './index.module.scss';
import EfImg from '@elem/ui/ef-img';

type ItemType = {
    icon: JSX.Element | ReactNode;
    title: string;
    desc: string;
};
export default function ModalAU({ visible, callback }: any) {
    const [open, setOpen] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('theProduct.TabC');

    const items: ItemType[] = [
        {
            icon: (
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6.83301" y="6.8335" width="36.3333" height="33.8333" rx="4" stroke="black" strokeWidth="2" />
                    <path d="M25 12.5L25 20.8333" stroke="black" strokeWidth="2" strokeLinecap="round" />
                    <path d="M34.5827 26.25L29.166 33.75" stroke="black" strokeWidth="2" strokeLinecap="round" />
                    <path d="M15.4163 26.25L20.833 33.75" stroke="black" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
            title: t('win3_a_item1_t'),
            desc: t('win3_a_item1_b'),
        },
        {
            icon: (
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8337 39.5833H7.1632C5.71138 39.5833 4.70473 38.1356 5.21023 36.7746L9.58366 25" stroke="black" strokeWidth="2" />
                    <path d="M9.16699 25H41.667" stroke="black" strokeWidth="2" />
                    <path d="M17.917 12.0835L24.5837 40.0002" stroke="black" strokeWidth="2" />
                    <path d="M27.917 12.0835L35.0003 40.0002" stroke="black" strokeWidth="2" />
                    <path
                        d="M6.92153 15.1036C6.58143 13.785 7.57708 12.5 8.93884 12.5H37.2339C38.1841 12.5 39.0139 13.1429 39.2512 14.063L45.1618 36.9797C45.5019 38.2983 44.5062 39.5833 43.1445 39.5833H13.2353L6.92153 15.1036Z"
                        stroke="black"
                        strokeWidth="2"
                    />
                </svg>
            ),
            title: t('win3_a_item2_t'),
            desc: t('win3_a_item2_b'),
        },
        {
            icon: (
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.167 10.4165V16.2718V19.7717C14.167 20.5697 14.4574 21.3441 15.1184 21.7912C16.5011 22.7264 19.52 24.1665 25.0003 24.1665C30.4806 24.1665 33.4995 22.7264 34.8822 21.7912C35.5433 21.3441 35.8337 20.5697 35.8337 19.7717V10.4165"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M25 15.1667C27.6828 15.1667 30.3249 14.6323 32.3306 13.7375C33.3319 13.2907 34.2205 12.7336 34.8732 12.067C35.528 11.3981 36 10.5579 36 9.58333C36 8.60878 35.528 7.76854 34.8732 7.09972C34.2205 6.43304 33.3319 5.87598 32.3306 5.4292C30.3249 4.53432 27.6828 4 25 4C22.3172 4 19.6751 4.53432 17.6694 5.4292C16.6681 5.87598 15.7795 6.43304 15.1268 7.09972C14.472 7.76854 14 8.60878 14 9.58333C14 10.5579 14.472 11.3981 15.1268 12.067C15.7795 12.7336 16.6681 13.2907 17.6694 13.7375C19.6751 14.6323 22.3172 15.1667 25 15.1667Z"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M17.5 32.0835V34.5835C17.5 37.575 20.8579 40.0002 25 40.0002C29.1421 40.0002 32.5 37.575 32.5 34.5835V28.3335"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <circle cx="24.9997" cy="19.1667" r="1.66667" fill="black" />
                    <path
                        d="M17.5 22.5V32.7654C17.5 33.4317 17.899 34.0283 18.5406 34.2084C19.7312 34.5428 21.9219 35 25 35C28.0781 35 30.2688 34.5428 31.4594 34.2084C32.101 34.0283 32.5 33.4317 32.5 32.7654V22.5"
                        stroke="black"
                        strokeWidth="2"
                    />
                    <path
                        d="M17.5003 25.8335H15.8337C14.9132 25.8335 14.167 26.5797 14.167 27.5002V31.6668C14.167 32.5873 14.9132 33.3335 15.8337 33.3335H17.5003"
                        stroke="black"
                        strokeWidth="1.66667"
                    />
                    <path
                        d="M32.4997 25.8335H34.1663C35.0868 25.8335 35.833 26.5797 35.833 27.5002V31.6668C35.833 32.5873 35.0868 33.3335 34.1663 33.3335H32.4997"
                        stroke="black"
                        strokeWidth="1.66667"
                    />
                    <path
                        d="M23.333 40L23.333 41.25C23.333 42.4006 24.2657 43.3333 25.4163 43.3333V43.3333C26.5669 43.3333 27.4997 42.4006 27.4997 41.25V40"
                        stroke="black"
                        strokeWidth="1.66667"
                    />
                    <path d="M21.667 8.3335H28.3337" stroke="black" strokeWidth="1.33333" strokeLinecap="round" />
                    <path d="M21.667 10.8335H28.3337" stroke="black" strokeWidth="1.33333" strokeLinecap="round" />
                </svg>
            ),
            title: t('win3_a_item3_t'),
            desc: t('win3_a_item3_b'),
        },
        {
            icon: (
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M40.625 32.8125L40.625 17.1875C40.625 15.4616 39.2259 14.0625 37.5 14.0625L10.9375 14.0625C9.21161 14.0625 7.8125 15.4616 7.8125 17.1875L7.8125 32.8125C7.8125 34.5384 9.21161 35.9375 10.9375 35.9375L37.5 35.9375C39.2259 35.9375 40.625 34.5384 40.625 32.8125Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M45.3125 28.125L45.3125 21.875L40.625 20.3125L40.625 29.6875L45.3125 28.125Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M21.875 14.0625L21.875 10.9375L14.0625 10.9375L14.0625 14.0625L21.875 14.0625Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M25 10.9375L25 7.8125L10.9375 7.8125L10.9375 10.9375L25 10.9375Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M15.625 17.9688L31.25 17.9687" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.625 22.6562L31.25 22.6562" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.625 27.3438L31.25 27.3437" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M15.625 32.0312L31.25 32.0312" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M34.375 38.9583L34.375 35.9375L12.5 35.9375L12.5 38.9583C12.5 39.8788 13.2462 40.625 14.1667 40.625L32.7083 40.625C33.6288 40.625 34.375 39.8788 34.375 38.9583Z"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            title: t('win3_a_item4_t'),
            desc: t('win3_a_item4_b'),
        },
    ];

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            callback && callback();
        }, 500);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        setOpen(visible);
    }, [visible]);

    return (
        <>
            {isClient &&
                createPortal(
                    <div className={`modal ${css.modal} ${open ? 'open' : 'close'}`}>
                        <div className="content">
                            <svg
                                className="close"
                                onClick={handleClose}
                                xmlns="http://www.w3.org/2000/svg"
                                width="1em"
                                height="1em"
                                viewBox="0 0 40 40"
                                fill="none"
                            >
                                <rect width="40" height="40" rx="20" fill="#F4F4F4"></rect>
                                <path d="M27.5 27.5L12.5 12.5" stroke="#707070" strokeWidth="3.64072" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M27.5 12.5L12.5 27.5" stroke="#707070" strokeWidth="3.64072" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                            <div className="brief">
                                <div className="img-box">
                                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1736821168102/5_R3_UPS.png" />
                                </div>
                                <p className="title">{t('win3_a_title')}</p>
                            </div>
                            <ul className="items">
                                {items.map((item: ItemType, k: number) => (
                                    <li className="item" key={k}>
                                        {item.icon}
                                        <p className="item-desc">{item.desc}</p>
                                        <p className="item-title">{item.title}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>,
                    document.body,
                )}
        </>
    );
}
